// @flow
import { getCreator, postCreator, deleteCreator } from '../../../http/index';
import environment from '../../../environment/index';

export const endpoints = Object.freeze({
  GET_NOTIFICATIONS: `${environment.apiUrl}/notification/`,
  GET_UNSEEN: `${environment.apiUrl}/notification/unseen`,
  SEE_ALL_NOTIFICATION: `${environment.apiUrl}/notification/see`,
  HIDE_NOTIFICATION: `${environment.apiUrl}/notification/:id`,
  READ_NOTIFICATION: `${environment.apiUrl}/notification/read/:id`,
});

export const getNotificationsApi = getCreator(fetch, endpoints.GET_NOTIFICATIONS);
export const getUnseenApi = getCreator(fetch, endpoints.GET_UNSEEN);
export const seeAllNotificationApi = postCreator(fetch, endpoints.SEE_ALL_NOTIFICATION);
export const hideNotificationApi = deleteCreator(fetch, endpoints.HIDE_NOTIFICATION);
export const readNotificationApi = postCreator(fetch, endpoints.READ_NOTIFICATION);



// WEBPACK FOOTER //
// ./src/modules/navbar/notifications/api.js